/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invite_User_DescriptionInputs */



/**
* | output |
* | --- |
* | "Invite another admin to this partner's portal." |
*
* @param {Partner_Admin_Invite_User_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invite_user_description = /** @type {((inputs?: Partner_Admin_Invite_User_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invite_User_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden Sie einen weiteren Admin in das Portal dieses Partners ein.")
	return /** @type {LocalizedString} */ ("Invite another admin to this partner's portal.")
});